<template>
<div>
  <!-- NAVIGATION MENU -->
  <button class="btn_menu" :class="{active: $store.state.menu.active}" @click="toggleMenu"></button>
  <nav>
    <ul>
      <li>
        <router-link to="/"><img src="../../assets/img/icon-home.png" alt="Accueil" /></router-link>
      </li>
      <li v-if="userId">
        <router-link to="/cartographies">CARTOGRAPHIE</router-link>
      </li>
      <li v-if="userId">
        <router-link to="/incidents">LISTE DES INCIDENTS TNT</router-link>
      </li>
      <li v-if="userId">
        <router-link to="/stations" >STATIONS 4G/5G</router-link>
      </li>
      <li v-if="userId">
        <a id="redirect_recevoirlatnt" :href="urlRedirectRecevoirTnt+'/#!/?antenniste=true'" target="_blank">REMONTER UN PROBLÈME</a>
      </li>
      <li v-if="userPartenaire">
        <router-link to="/parametrages" >PARAMETRAGES</router-link>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
import storeJs from 'store'
import * as eventTypes from '../../bus/event-types.js'
import EventBus from '../../bus'
export default {
  name: 'CrMenu',
  components: {},
  data() {
    return {
      userId: storeJs.get('prtv:user-id'),
      userPartenaire: storeJs.get("prtv:user-partenaire"),
      urlRedirectRecevoirTnt: storeJs.get("prtv:url-redirectRecevoirTnt") ? storeJs.get("prtv:url-redirectRecevoirTnt") : 'https://assistance.recevoirlatnt.fr'
    }
  },

  mounted() {
    EventBus.$on(eventTypes.EVENT_USER_INFO, () => {
      this.userId = storeJs.get('prtv:user-id');
      this.userPartenaire =  storeJs.get("prtv:user-partenaire");
      this.urlRedirectRecevoirTnt = storeJs.get("prtv:url-redirectRecevoirTnt");
    })
  },

  methods: {
    toggleMenu: function() {
      this.$store.dispatch('menuToggle')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
